export const documentsTableColumns = [
  {
    prop: 'name',
    title: 'common.fields.name',
    width: '15%',
    sortingEnabled: true,
  },
  {
    prop: 'description',
    title: 'common.fields.description',
    width: '57%',
    sortingEnabled: true,
  },
  {
    prop: 'editable_by_client',
    title: 'common.fields.client_editable',
    width: '10%',
    sortingEnabled: false,
  },
  {
    prop: 'editable_by_foreigner',
    title: 'common.fields.foreigner_editable',
    width: '10%',
    sortingEnabled: false,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '8%',
    sortingEnabled: false,
  },
];
